module.exports = __webpack_public_path__ + "img/candle-burning-1.ed01e8c7.png";